import { render, staticRenderFns } from "./HomeworkRegister.vue?vue&type=template&id=942b9fc4&scoped=true"
import script from "./HomeworkRegister.vue?vue&type=script&lang=js"
export * from "./HomeworkRegister.vue?vue&type=script&lang=js"
import style0 from "./HomeworkRegister.vue?vue&type=style&index=0&id=942b9fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942b9fc4",
  null
  
)

export default component.exports